import { render, staticRenderFns } from "./RatebaseAdd.vue?vue&type=template&id=356e904d&scoped=true&"
import script from "./RatebaseAdd.vue?vue&type=script&lang=js&"
export * from "./RatebaseAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356e904d",
  null
  
)

export default component.exports